import { render, staticRenderFns } from "./OrganizationMdtDiseaseDetail.vue?vue&type=template&id=6a7e8742&scoped=true"
import script from "./OrganizationMdtDiseaseDetail.vue?vue&type=script&lang=js"
export * from "./OrganizationMdtDiseaseDetail.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMdtDiseaseDetail.vue?vue&type=style&index=0&id=6a7e8742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7e8742",
  null
  
)

export default component.exports